// extracted by mini-css-extract-plugin
export var customImage = "Share-module--customImage--d2ade";
export var layout = "Share-module--layout--99e93";
export var loading = "Share-module--loading--7dfc3";
export var pageMessage = "Share-module--pageMessage--814dd";
export var title = "Share-module--title--f57b1";